import PropTypes from "prop-types";

const options = [
  { value: "To Do", text: "To Do", className: "status-not-done" },
  {
    value: "Resources Identified",
    text: "Resources Identified",
    className: "status-not-done",
  },
  {
    value: "Resources In Use",
    text: "Resources In Use",
    className: "status-done",
  },
];

const Progress = ({ status, responseId, changeProgressStatus, showSelectedValueOnly }) => {
  const defaultOption = options[0];

  const handleOnChange = (event) => {
    changeProgressStatus({
      responseId: responseId,
      newStatus: event.target.value,
    });
  };

  const getStatusClassName = () => {
    const option = options.find((o) => o.value === status);
    return option ? option.className : defaultOption.className;
  };

  if (showSelectedValueOnly) {
    return <div className={getStatusClassName()}>{status || defaultOption.text}</div>;
  }
  return (
    <div className="status-select react-select-container">
      <div className="select-label">Status:</div>
      <span className="select-wrap">
        <select
          className="select lists-dropdown"
          value={status || defaultOption.value}
          onChange={handleOnChange}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </span>
    </div>
  );
};

Progress.propTypes = {
  status: PropTypes.string,
  responseId: PropTypes.number.isRequired,
  changeProgressStatus: PropTypes.func.isRequired,
  showSelectedValueOnly: PropTypes.bool,
};

export default Progress;
